import { useFormContext, useWatch } from 'react-hook-form';

import { fieldMustBeNumber } from '@xemplo/gp-utils';
import { NumberFieldRhf } from '@xemplo/number-field';

import { FormFields } from '../../../create-amendment.types';
import * as S from '../../modal.styles';

export const PaymentPeriods = () => {
  const { control } = useFormContext<FormFields>();
  const lumpSum = useWatch({ control, name: 'lumpSum' });
  const taxCalculationMethod = useWatch({ control, name: 'taxCalculationMethod' });
  const paymentPeriods = useWatch({ control, name: 'paymentPeriods' });
  const showPaymentPeriods = lumpSum === 'Yes' && taxCalculationMethod === 'A';

  if (!showPaymentPeriods) {
    if (paymentPeriods) {
      control.unregister('paymentPeriods');
    }
    return null;
  }
  return (
    <S.FormLabel>
      Payment Periods
      <NumberFieldRhf
        placeholder="Enter payment periods"
        aria-label="Payment periods field"
        name="paymentPeriods"
        rules={{
          required: 'This field is required',
          validate: fieldMustBeNumber,
        }}
      />
    </S.FormLabel>
  );
};
